import gql from 'graphql-tag';

const accountMarketingMaterialConfigurationSet = gql`
  mutation accountMarketingMaterialConfigurationSet(
    $input: AccountMarketingMaterialConfigurationSetInput!
  ) {
    accountMarketingMaterialConfigurationSet(input: $input) {
      account_marketing_material_configuration {
        album_folder {
          id
          marketing_materials(slice: { limit: 999 }) {
            total
            records {
              id
              type
              pdf_url
              image_url
            }
          }
        }
      }
    }
  }
`;

export default accountMarketingMaterialConfigurationSet;
